import * as _ from 'underscore';

import * as appTheme from '../../../../_common/platform/ts/appTheme';

declare var require: any;

var template = require('!!raw-loader!pdc-widget-multiple/src/mainTheme.template.css').default;

import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { validators } from '../../../../_common/platform/ts/validators';

import { ColorBoxField } from '../../../../_common/platform/ts/ColorBoxField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import BooleanField from '../../../../_common/platform/ts/BooleanField';
import SelectField from '../../../../_common/platform/ts/SelectField';
import { FontField } from '../../../../_common/platform/ts/FontField';
import { themeFields } from '../config';

declare var Color: any;

template;

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);

    appTheme.registerSections([
        {
            id: 'widget-multiple',
            name: 'Tabbed Container',
            parent: 'widget',

            themeType: 'Tabbed Widget Container',
            visibility: ['application', 'workspace', 'pdc-widget-multiple']
        }
    ]);

    appTheme.registerGroups([
        {
            id: 'widget-multiple-tabs-font',
            name: 'Font of Tabs',
            section: 'widget-multiple'
        },
        {
            id: 'widget-multiple-mobile',
            name: 'Small Devices Look and Feel',
            section: 'widget-multiple'
        }
    ]);

    appTheme.registerVars([
        {
            id: themeFields.widgetMultipleTabPosition,
            param: new SelectField(glob, 'Widget Tabs Position', [], 'top', {
                values: ['top', 'right', 'bottom', 'left'],
                display: ['Top', 'Right', 'Bottom', 'Left']
            }),
            section: 'widget-multiple'
        },

        {
            id: 'widget-multiply-tab-style',
            param: new SelectField(glob, 'Widget Tabs Style', [], 'icon_text', {
                values: ['icon_text', 'text_only', 'icon_only'],
                display: ['Icon and Text', 'Text Only', 'Icon Only']
            }),
            section: 'widget-multiple'
        },

        {
            id: 'widget-multiple-wrap',
            param: new BooleanField(glob, 'Wrap Tabs', [], true),
            section: 'widget-multiple'
        },
        {
            id: 'widget-multiple-next-prev',
            param: new BooleanField(glob, 'Next/Previous Buttons', [], false),
            section: 'widget-multiple'
        },

        //LL: 07.01.23: rem Height. Was "Allow to apply Width and Height when Tabs are ... "
        //LL: 29.12.22: new option, needed not to spoil current WSs. Earlier W & H were not applied to .nav-tabs
        {
            id: 'widget-multiple-applyWidthAndHeight-navTabs',
            param: new BooleanField(
                glob,
                'Allow to apply Width when Tabs are "navTabs" ("Wrap Tabs" is Off or "Material Style" is used)',
                [],
                false
            ),
            section: 'widget-multiple'
        },

        {
            id: 'widget-multiple-tab-width',
            param: new NumberField(
                glob,
                'Width of Tab (keep empty for Automatic value) - applied only when Tab Position is "top"',
                [
                    validators.number.integer,
                    validators.number.positive,
                    validators.number.range(40, 500) // padding = 16
                ],
                null, //100,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: 'widget-multiple'
        },
        {
            id: 'widget-multiple-tab-height',
            param: new NumberField(
                glob,
                'Height of Tab (keep empty for Automatic value) - applied only when Tab Position is "top"',
                [
                    validators.number.integer,
                    validators.number.positive,
                    validators.number.range(24, 150) //  16 + 8  padding = 8
                ],
                null, //30,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: 'widget-multiple'
        },
        {
            id: themeFields.widgetMultipleTabIconSize,
            param: new NumberField(
                glob,
                'Icon Size on Tab (keep empty for Automatic value)',
                [validators.number.integer, validators.number.positive, validators.number.range(6, 150)],
                null, //24,
                {
                    allowNull: true,
                    applyOnEnter: true
                }
            ),
            section: 'widget-multiple'
        },
        {
            id: 'widget-multiple-tab-default-bg',
            param: new ColorBoxField(
                glob,
                'Default Background Color of Tabs',
                [],
                'transparent', //null, //LL: null value causes error
                { hideTransparency: false, showTex: true }
            ),
            section: 'widget-multiple'
        },

        {
            id: 'widget-multiple-tab-default-color',
            param: new ColorBoxField(
                glob,
                'Default Text Color of Tabs',
                [],
                function (theme) {
                    return Color(theme['gray-base']).mix(Color(theme['surface-bg']), 0.2).hexString();
                },
                { hideTransparency: true, showTex: true }
            ),
            section: 'widget-multiple'
        },

        {
            id: 'widget-multiple-tab-font-face',
            param: new FontField(glob, 'Font Face', [], null, {}),
            section: 'widget-multiple',
            group: 'widget-multiple-tabs-font'
        },
        {
            id: 'widget-multiple-tab-font-size',
            param: new SelectField(glob, 'Tab Font Size', [], 'default', {
                values: [
                    'default',
                    'xx-small',
                    'x-small',
                    'small',
                    'medium',
                    'large',
                    'x-large',
                    'xx-large',
                    'smaller',
                    'larger'
                ],
                display: [
                    'default',
                    'xx-small',
                    'x-small',
                    'small',
                    'medium',
                    'large',
                    'x-large',
                    'xx-large',
                    'smaller',
                    'larger'
                ]
            }),
            section: 'widget-multiple',
            group: 'widget-multiple-tabs-font'
        },
        {
            id: 'widget-multiple-tab-font-weight',
            param: new SelectField(glob, 'Font Weight', [], 'normal', {
                values: ['lighter', 'normal', 'bold', 'bolder'],
                display: ['lighter', 'normal', 'bold', 'bolder']
            }),
            section: 'widget-multiple',
            group: 'widget-multiple-tabs-font'
        },
        {
            id: 'widget-multiple-tab-font-italic',
            param: new BooleanField(glob, 'Tab Font Italic', [], false),
            section: 'widget-multiple',
            group: 'widget-multiple-tabs-font'
        },

        {
            id: 'widget-multiply-tab-look-and-feel',
            param: new SelectField(glob, 'Widget Tabs Look and Feel', [], 'tabs', {
                values: ['tabs', 'menu', 'buttons'],
                display: ['Tabs', 'Dropdown Menus', 'Button Group']
            }),
            section: 'widget-multiple',
            group: 'widget-multiple-mobile'
        },
        {
            id: 'widget-multiple-always-start-from-begining',
            param: new BooleanField(glob, 'Always open first tab on start', [], true),
            section: 'widget-multiple',
            group: 'widget-multiple-mobile'
        },
        {
            id: 'widget-multiply-reset-drill-down',
            param: new BooleanField(glob, 'Reset Drill Down State', [], true),
            section: 'widget-multiple',
            group: 'widget-multiple-mobile'
        }
    ]);

    appTheme.registerTemplate(template, ['pdc-widget-multiple']);

    _init.push(glob);
}
